export function isRenewalRestricted(status) {
  return status === 'Registered (SGNIC serverRenewProhibited)';
}

export function isRegisteredDomain(status) {
  return status === 'Active' || isRenewalRestricted(status);
}
